import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Login } from "./features/authorization/pages/Login";
import { AppLayout } from "./shared/components/Layout/AppLayout";
import { OrdersPage } from "./features/orders/pages/OrdersPage";
import { ManualFlightsPage } from "./features/manual-flights/pages/ManualFlightsPage";
import { MarkupsPage } from "./features/markups/pages/MarkupsPage";
import { NotificationsPage } from "./features/notifications/pages/NotificationsPage";
import { UsersPage } from "./features/users/pages/UsersPage";
import { LogsPage } from "./features/logs/pages/LogsPage";
import { SettingsPage } from "./features/settings/pages/SettingsPage";
import { ProtectedRoute } from "./shared/components/ProtectedRoute";
import { AddUserPage } from "./features/authorization/pages/add-user-page/AddUserPage";
import OrderDetailsPage from "./features/orders/components/OrderDetail/OrderDetail";
import { NotificationDetailPage } from "./features/notifications/components/details/NotificationDetails";
import { Toaster } from "sonner";
import { ForgotPassword } from "./features/authorization/components/forgot-password/ForgotPassword";
import { ToursPage } from "./features/tours/pages/ToursPage";
import { EntryRulesPage } from "./features/entry-rules/pages/EntryRulesPage";

export function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/add-user" element={<AddUserPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/*" element={<AppLayout />}>
            <Route index element={<OrdersPage />} />
            <Route path="manual-flights" element={<ManualFlightsPage />} />
            <Route path="markups" element={<MarkupsPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route
              path="notifications/details"
              element={<NotificationDetailPage />}
            />
            <Route path="users" element={<UsersPage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="tours" element={<ToursPage />} />
            <Route path="entry-rules" element={<EntryRulesPage />} />
            <Route path="orders/:id" element={<OrderDetailsPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
